import styled from 'styled-components';

export const CategoryNameStyled = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  margin: 5px 0px;
  overflow-x: hidden;
`;

export const DragIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 5px;
`;
